import { Notify } from "notiflix/build/notiflix-notify-aio";


export async function toastErroCarregar(mensagem) {
    Notify.failure(mensagem);
}
